/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Velocity from 'velocity-animate';
import ArrowDown from '../../../components/svg/arrow-down';

export class CountryPicker extends React.Component {

  static propTypes = {
    countries: PropTypes.array.isRequired,
    selectedCountry: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      menuOpen: false
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
  }

  handleMenuToggle () {
    this.setState({
      menuOpen: !this.state.menuOpen
    }, () => {
      if (this.state.menuOpen) {
        Velocity(this.refs.menu, 'slideDown', {duration: 200});
      } else {
        Velocity(this.refs.menu, 'slideUp', {duration: 200});
      }
    });
  }

  render () {
    return (
      <ul className='select-list hide-tablet' role='menu' onClick={this.handleMenuToggle}>
        <li>
          <span className='selected'>
            <Translate content='SWEDEN'/>
            <span className="ml-10"><ArrowDown width='15px' height='10px' color='blue-light' /></span>
          </span>

          <ul className='select-list-sub country-menu' role='menu' aria-hidden='true' ref='menu'>
            <li role='menuitem'><a href='https://www.invoicery.dk/'><Translate content='DENMARK'/></a></li>
            <li role='menuitem'><a href='https://www.frilansfinans.fi/'><Translate content='FINLAND'/></a></li>
            <li role='menuitem'><a href='https://www.frilansfrance.fr/'><Translate content='FRANCE'/></a></li>
            <li role='menuitem'><a href='https://www.frilansfinans.no'><Translate content='NORWAY'/></a></li>
            <li role='menuitem'><a href='#'><Translate content='SWEDEN'/></a></li>
            <li role='menuitem'><a href='https://www.invoicery.co.uk/'><Translate content='UK'/></a></li>
          </ul>
        </li>
      </ul>
    );
  }
}

export default CountryPicker;



/** WEBPACK FOOTER **
 ** ./src/components/header/country-picker/country-picker.js
 **/